/* eslint-disable prettier/prettier */
import { memo, useContext } from 'react';

import { Button } from '@/components/old';

import { AddressType } from '@/api/types';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import '../BirthdayUpdateAlert/BirthdayUpdateAlert.scss';

export type AddressCheckAlertAddressType = AddressType.REGISTRATION | AddressType.LIVING;

export interface AddressCheckAlertProps {
  addressType: Nullable<AddressCheckAlertAddressType>;
}

export const AddresCheckAlert = memo<AddressCheckAlertProps>(function AddresCheckAlert({ addressType }) {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.yellow}>
      <div className="birthday-alert">
        <div className="birthday-alert__title">
          Нова адреса місця зберігання має відрізнятися від Вашого{' '}
          {addressType === AddressType.REGISTRATION ? 'зареєстрованого' : 'задекларованого'} місця проживання
        </div>

        <div className="birthday-alert__buttons-box">
          <Button isMaxWidth={true} isBorder={true} onClick={(): void => toggleModal(false)}>
            Закрити
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
